export const ENGAGEMENT_PANEL_ACTIONS = Object.freeze({
  NOTIFY_MESSAGE: 'NOTIFY_MESSAGE',
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',
  OPEN_PANEL: 'OPEN_PANEL',
  SET_TOAST_CONTAINER_ID: 'SET_TOAST_CONTAINER_ID',
  SET_ACTIVE_PANEL: 'SET_ACTIVE_PANEL'
});

export const NOTIFICATION_TYPE = Object.freeze({
  IN_APP: 'IN_APP',
  PUSH: 'PUSH'
});

export const ENGAGEMENT_MESSAGE_TYPE = Object.freeze({
  BADGE: 'badge',
  TOAST: 'toast',
  NONE: 'none'
});

export const ENGAGEMENT_PANEL_IDS = Object.freeze({
  LIVE_QA: 'liveqa',
  LIVE_POLLING: 'polls',
  SURVEY: 'survey',
  CHAT: 'chat',
  MEET_NOW: 'meet-now',
  SCHEDULE: 'schedule-btn',
  INBOUND_LEADS: 'inbound-leads',
  AGENDA_ITEM_REMINDERS: 'agenda-item-reminders',
  PLANNER_NOTIFICATIONS: 'planner-notifications',
  CODE_WIDGETS: 'code-widgets',
  PARTICIPANTS: 'participants',
  MODERATOR_ENGAGEMENT: 'moderator-engagement',
  RESOURCES: 'attendee-resources'
});

export const ENGAGEMENT_MESSAGE_TRIGGERS = Object.freeze({
  CHAT_STARTED: 'chat_started',
  LIVE_POLLING_QUESTION_OPENED: 'poll_question_opened',
  LIVE_QA_OPENED: 'live_qa_opened',
  LIVE_CHAT_OPENED: 'live_chat_opened',
  LIVE_QA_NEW_QUESTIONS_AVAILABLE: 'new_questions_available',
  LIVE_QA_QUESTION_ANSWERED: 'question_answered',
  SURVEY_OPENED: 'survey_opened',
  PLANNER_MESSAGES: 'planner_messages'
});

/** Width requirement for the Engagement Panel Toggles section */
export const ENGAGEMENT_PANEL_COLLAPSED_WIDTH = 104;
/** Width requirement for the Engagement Panel Content */
export const ENGAGEMENT_PANEL_CONTENT_WIDTH = 384;
/** Width requirement for the Engagement Panel Content + Toggles section */
export const ENGAGEMENT_PANEL_EXPANDED_WIDTH = 488;
export const DEFAULT_AUTO_HIDE_TIMEOUT = 6_000; // 6 seconds
export const CUSTOM_WIDGET_TYPE = 'CUSTOM_WIDGET_TYPE';

export const CVENT_BRANDING = 'CVENT_BRANDING';
export const FEATURE_SPEED_NETWORKING = 'SPEED_NETWORKING';
export const FEATURE_VIDEO_DISCUSSIONS = 'VIDEO_DISCUSSIONS';
export const FEATURE_MESSAGING = 'MESSAGING';

// The id of the target element for the toast portal created in PageHeader
// Note: By default, the toast portal is created in the page header.
// However, if you want to change the toast portal to a different location,
// you can use setToastContainerId from useEngagementMessages hook.
export const TOAST_PORTAL_CONTAINER_ID = 'toast-portal-container-id';
